import React, { Fragment } from 'react'
import { List, Datagrid, Filter, ShowButton, TextInput, TextField, Button, EditButton, BulkDeleteButton, FunctionField, DeleteButton } from 'react-admin'
import { ContentWriterStatusSelectInput } from '../../UI/Input/SelectInput'
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ContentWriterStatusSelectInput label="Status" source="status" />
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const TeamLeaderList = ({ ...props }) => {

    return (
        <List {...props} title="Team Leaders" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'name', order: 'ASC' }}>

            <Datagrid >
                <TextField source="id" />
                <TextField source="name" label="Name" />
                <TextField source="profile_id" label="Profile ID" />
                <TextField source="commentors_count" label="Team Member Count" />
                <TextField source="telegram_link" label="Telegram Link" />
                {useCheckPermissions('TeamLeader_View')?<ShowButton />:null}
            </Datagrid>

        </List>
    )
}


export default TeamLeaderList